import React from 'react';
import {Modal, Text, Icon} from '@/ui-kits';
import {NA} from '@/constants/defaults';
import { AssignedAdmin } from '@/interface';

interface AssignedAdminModalProps {
  isOpen: boolean;
  onClose: () => void;
  roleName: string;
  assignedAdmins: AssignedAdmin[];
}

export const AssignedAdminModal: React.FC<AssignedAdminModalProps> = ({
  isOpen,
  onClose,
  roleName,
  assignedAdmins,
}) => {
  if (!isOpen) return null;

  const columns = [
    {title: 'ADMIN ID', width: 'w-1/4'},
    {title: 'NAME', width: 'w-1/3'},
    {title: 'E-MAIL ID', width: 'w-2/5'},
  ];

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="rounded-xl w-[95vw] sm:w-[92vw] md:w-[85vw] lg:w-[75vw] xl:w-[65vw] 2xl:w-[60vw] max-w-[900px] bg-white p-0 overflow-hidden border-[1px] border-ui_input_border">
      <div className="flex flex-col h-full max-h-[85vh] sm:max-h-[80vh]">
        {/* Header */}
        <div className="flex items-start justify-between px-4 sm:px-6 py-3 sm:py-4 pb-2 bg-white gap-2">
          <Text variant="free" className="text-ui_blue font-FigtreeBold text-base sm:text-lg lg:text-xl break-words pr-2 flex-1 min-w-0">
            Role: {roleName} – Assigned Admins ({assignedAdmins.length})
          </Text>
          <button
            onClick={onClose}
            className="text-ui_blue hover:text-ui_blue_light transition-colors p-1.5 rounded-full hover:bg-gray-100 flex-shrink-0 mt-0.5"
            title="Close">
            <Icon type="close" className="size-5 sm:size-6" />
          </button>
        </div>

        {/* Table Content */}
        <div className="flex-1 overflow-y-auto px-3 sm:px-4 md:px-6 pb-4 sm:pb-6 pt-2 min-h-0">
          <div className="w-full border-[1px] border-ui_input_border rounded-lg overflow-hidden">
            {/* Table Header - Sticky */}
            <div className="sticky top-0 z-10 grid grid-cols-12 gap-2 sm:gap-4 bg-ui_sky_blue px-3 sm:px-4 md:px-6 py-3 sm:py-4 border-b-[1px] border-b-ui_input_border">
              {columns.map((col, index) => (
                <div key={col.title} className={index === 0 ? 'col-span-3' : index === 1 ? 'col-span-4' : 'col-span-5'}>
                  <Text variant="free" className="font-FigtreeBold text-sm sm:text-base text-ui_blue whitespace-nowrap">
                    {col.title}
                  </Text>
                </div>
              ))}
            </div>

            {/* Table Body - Scrollable */}
            <div className="max-h-[calc(80vh-200px)] overflow-y-auto">
              {assignedAdmins.length > 0 ? (
                assignedAdmins.map((admin, index) => (
                  <div
                    key={admin.id}
                    className={`grid grid-cols-12 gap-2 sm:gap-4 px-3 sm:px-4 md:px-6 py-3 sm:py-4 bg-white items-start ${index !== assignedAdmins.length - 1 ? 'border-b-[1px] border-b-ui_input_border' : ''}`}>
                    <div className="col-span-3 min-w-0">
                      <Text variant="free" className="font-FigtreeSemiBold text-sm sm:text-base text-ui_input_border_dark truncate">
                        {admin.id ?? NA}
                      </Text>
                    </div>
                    <div className="col-span-4 min-w-0 break-words">
                      <Text variant="free" className="font-FigtreeBold text-sm sm:text-base text-ui_input_border_dark break-words">
                        {admin.name ?? NA}
                      </Text>
                    </div>
                    <div className="col-span-5 min-w-0 break-words">
                      <Text variant="free" className="font-FigtreeSemiBold text-sm sm:text-base text-ui_input_border_dark break-words">
                        {admin.email ?? NA}
                      </Text>
                    </div>
                  </div>
                ))
              ) : (
                <div className="px-4 sm:px-6 py-6 sm:py-8 text-center bg-white">
                  <Text variant="body" className="text-ui_input_border_dark">
                    No assigned admins found.
                  </Text>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

